import axios from "axios";
import { Country } from "../models/Country";

const BASE_URL = "https://artapi-fqcedhg8c0h9erew.westeurope-01.azurewebsites.net/api";

export const fetchCountries = async (): Promise<Country[]> => {
    const response = await axios.get(`${BASE_URL}/countries`);
    return response.data;
};
